/* eslint-disable no-unused-vars */
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ACCOUNTING_CLASSES_ACTION_TYPE = createNamedActions('accountingClasses', {
  GET_CLASSES: 'GET_CLASSES',
});

export const getAccountingClassesAction = catchAsyncActionError(params => async dispatch => {
  // const { data } = await accountingApi.getClasses(params);
  // return dispatch({
  //   type: ACCOUNTING_CLASSES_ACTION_TYPE.GET_CLASSES,
  //   payload: data,
  // });
});
